var map = {
	"./3Crv-logo.png": 1389,
	"./AAVE-logo.png": 1390,
	"./COMP-logo.png": 1391,
	"./CRV-logo.png": 1392,
	"./DAI-logo.png": 1393,
	"./ETH-logo.png": 1394,
	"./LEND-logo.png": 1395,
	"./LINK-logo.png": 1396,
	"./MANA-logo.png": 1397,
	"./MBTC-logo.png": 1398,
	"./MKR-logo.png": 1399,
	"./MTA-logo.png": 1400,
	"./REN-logo.png": 1401,
	"./REP-logo.png": 1402,
	"./SNX-logo.png": 1403,
	"./SRM-logo.png": 1404,
	"./TUSD-logo.png": 1405,
	"./UNI-logo.png": 1406,
	"./USDC-logo.png": 1407,
	"./USDT-logo.png": 1408,
	"./WBTC-logo.png": 1409,
	"./WETH-logo.png": 1410,
	"./YFI-logo.png": 1411,
	"./ZRX-logo.png": 1412,
	"./cream-logo.png": 1413,
	"./crvBTC-logo.png": 1414,
	"./crvBUSD-logo.png": 1415,
	"./mUSD-logo.png": 1416,
	"./renBTC-logo.png": 1417,
	"./sBTC-logo.png": 1418,
	"./sUSD-logo.png": 1419,
	"./unknown-logo.png": 227,
	"./yCRV-logo.png": 1420,
	"./yDAI-logo.png": 1421,
	"./yUSD-logo.png": 1422,
	"./yWETH-logo.png": 1423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 323;